// Traditional English wording transcribed from the user's two leaflet photos.
// The official shrine link documents the prayers and their attribution;
// its modern English translation differs slightly from this supplied text.
export const FATIMA_PRAYER_SOURCE = "https://www.fatima.pt/en/pages/fatima-prayers";
export const FATIMA_SOURCE_LABEL = "Shrine of Fátima · prayers and attribution";
export const FATIMA_WORDING_NOTE = "Traditional English wording from The Fatima Prayers leaflet (Canadians for Faith & Family). The official shrine publishes a modern English translation.";
export const FATIMA_DECADE_PRAYER = "O my Jesus, forgive us our sins. Save us from the fire of hell. Lead all souls to Heaven, especially those who have most need of Thy mercy.";

export const FATIMA_PRAYERS = [
  {
    id: "fatima-pardon", title: "The Angel’s Pardon Prayer", group: "angel",
    subtitle: "Faith, adoration, hope and love",
    origin: "Taught by the Angel of Peace, the Guardian Angel of Portugal · 1916",
    context: "Taught to the children before the apparitions of Our Lady.",
    text: "My God, I believe, I adore, I hope and I love Thee. I ask pardon of Thee for all who do not believe, do not adore, do not hope and do not love Thee.",
  },
  {
    id: "fatima-angel-eucharistic", title: "The Angel’s Eucharistic Prayer", group: "angel",
    subtitle: "Adoration and reparation to the Most Holy Trinity",
    origin: "Taught by the Angel of Peace, the Guardian Angel of Portugal · 1916",
    context: "A prayer of Eucharistic adoration and reparation for the conversion of sinners.",
    text: "Most Holy Trinity, Father, Son and Holy Spirit, I adore Thee profoundly, and I offer Thee the most precious Body, Blood, Soul and Divinity of Jesus Christ, present in all the tabernacles of the world, in reparation for the outrages, sacrileges and indifference by which He Himself is offended; and by the infinite merits of His Most Sacred Heart, and through the Immaculate Heart of Mary, I beg of Thee the conversion of poor sinners.",
  },
  {
    id: "fatima-decade", title: "O My Jesus · The Fátima Prayer", group: "our-lady",
    subtitle: "After each decade of the Rosary",
    origin: "Taught by Our Lady of Fátima · 13 July 1917",
    context: "Prayed after each decade of the Rosary, traditionally after the Glory Be.",
    text: FATIMA_DECADE_PRAYER,
  },
  {
    id: "fatima-sacrifice", title: "The Sacrifice Prayer", group: "our-lady",
    subtitle: "For love of Jesus and the conversion of sinners",
    origin: "Taught by Our Lady of Fátima · 13 July 1917",
    context: "Prayed often, especially when offering a sacrifice, as described in the leaflet.",
    text: "O Jesus, it is for love of Thee, for the conversion of sinners, and in reparation for the sins committed against the Immaculate Heart of Mary.",
  },
];

export const FATIMA_LIBRARY_PRAYERS = FATIMA_PRAYERS.map((prayer) => ({
  ...prayer, cat: "fatima", tag: prayer.group === "angel" ? "Fátima · The Angel of Peace" : "Fátima · Our Lady",
  lines: [["English", prayer.text]], sourceUrl: FATIMA_PRAYER_SOURCE,
  sourceLabel: FATIMA_SOURCE_LABEL, sourceNote: FATIMA_WORDING_NOTE,
}));